/* tslint:disable */
import {
  AddStaticResponseFromPeliasRequest,
  AddStaticResponseFromPeliasResponse,
  AddStaticResponseRequest,
  AddStaticResponseResponse,
  AddressLocation,
  AtlasAddressComponent,
  CommonAddress,
  Country,
  GetAppleEmbedMapRequest,
  GetAppleEmbedMapResponse,
  GetAtlasStaticMapRequest,
  GetAtlasStaticMapResponse,
  GetEmbedMapRequest,
  GetEmbedMapResponse,
  GetPlaceRequest,
  GetPlaceResponse,
  GetSnapshotMapRequest,
  GetSnapshotMapResponse,
  GetStaticMapRequest,
  GetStaticMapResponse,
  ImageSize,
  IntenalGeolocation,
  IntenalSublocality,
  ListPredictionsRequest,
  ListPredictionsResponse,
  LocationDTO,
  MatchedSubstrings,
  Place,
  PredictRequest,
  PredictResponse,
  Prediction,
  ProvidersNames,
  Proximity,
  RemoveStaticResponseRequest,
  RemoveStaticResponseResponse,
  ReverseGeocodingRequest,
  ReverseGeocodingResponse,
  SearchByZipCodeRequest,
  SearchByZipCodeResponse,
  SearchRequest,
  SearchRequestV1,
  SearchResponse,
  SearchResponseV1,
  SearchResult,
  ServiceAddress,
  ServiceFilterBy,
  ServiceFilterByFilterType,
  ServiceGeolocation,
  ServiceSublocality,
  State,
  StaticResponseRequest,
  StaticResponseSearchResponse,
  StreetAddress,
  Subdivision,
  SubdivisionType,
  TextStructure,
  V2FilterBy,
  V2FilterByFilterType,
} from './types';

import { fromJson, toJson, batchFromJson, batchToJson } from '@wix/json-proto-serializer';
import { AmbassadorHTTPClient, AmbassadorHTTPClientConfig } from '@wix/ambassador/runtime/http';

import { AxiosInstance } from 'axios';
export const WixAtlasServiceWeb = (baseUrl: string, httpClientConfig?: AmbassadorHTTPClientConfig) => {
  const httpClient = new AmbassadorHTTPClient(baseUrl, httpClientConfig);

  return {
    AutocompleteServiceV2: () => {
      return (headers?: { [headerName: string]: any }) => {
        const service = {
          listPredictions: async (listPredictionsRequest: ListPredictionsRequest): Promise<ListPredictionsResponse> => {
            const requestTransformations = [{ typeName: 'google.protobuf.Int64Value', pathInPayload: ['radius'] }];
            const serializedPayload = batchToJson(listPredictionsRequest, requestTransformations);
            const response = await httpClient.invoke('GET', '/v2/predictions', serializedPayload, headers);
            return response;
          },
          predict: async (predictRequest: PredictRequest): Promise<PredictResponse> => {
            const requestTransformations = [{ typeName: 'google.protobuf.Int64Value', pathInPayload: ['radius'] }];
            const serializedPayload = batchToJson(predictRequest, requestTransformations);
            const response = await httpClient.invoke('POST', '/v2/predict', serializedPayload, headers);
            return response;
          },
        };
        (service as any).listPredictions.__http_method = 'GET';
        (service as any).listPredictions.__http_url = '/v2/predictions';
        (service as any).predict.__http_method = 'POST';
        (service as any).predict.__http_url = '/v2/predict';
        return service;
      };
    },
    LocationServiceV1: () => {
      return (headers?: { [headerName: string]: any }) => {
        const service = {
          search: (searchRequestV1: SearchRequestV1): Promise<SearchResponseV1> => httpClient.invoke('GET', '/api/v1/search', searchRequestV1, headers),
          searchByZipCode: (searchByZipCodeRequest: SearchByZipCodeRequest): Promise<SearchByZipCodeResponse> =>
            httpClient.invoke('GET', '/api/v1/search-by-zip-code', searchByZipCodeRequest, headers),
        };
        (service as any).search.__http_method = 'GET';
        (service as any).search.__http_url = '/api/v1/search';
        (service as any).searchByZipCode.__http_method = 'GET';
        (service as any).searchByZipCode.__http_url = '/api/v1/search-by-zip-code';
        return service;
      };
    },
    LocationServiceV2: () => {
      return (headers?: { [headerName: string]: any }) => {
        const service = {
          reverseGeocoding: (reverseGeocodingRequest: ReverseGeocodingRequest): Promise<ReverseGeocodingResponse> =>
            httpClient.invoke('GET', '/v2/location/reverse', reverseGeocodingRequest, headers),
          search: (searchRequest: SearchRequest): Promise<SearchResponse> => httpClient.invoke('GET', '/v2/search', searchRequest, headers),
        };
        (service as any).reverseGeocoding.__http_method = 'GET';
        (service as any).reverseGeocoding.__http_url = '/v2/location/reverse';
        (service as any).search.__http_method = 'GET';
        (service as any).search.__http_url = '/v2/search';
        return service;
      };
    },
    MapsWidgetServiceV0: () => {
      return (headers?: { [headerName: string]: any }) => {
        const service = {
          getAppleEmbedMap: (getAppleEmbedMapRequest: GetAppleEmbedMapRequest): Promise<GetAppleEmbedMapResponse> =>
            httpClient.invoke('GET', '/api/v1/dynamic-map-token', getAppleEmbedMapRequest, headers),
          getAtlasStaticMap: async (getAtlasStaticMapRequest: GetAtlasStaticMapRequest): Promise<GetAtlasStaticMapResponse> => {
            const response = await httpClient.invoke('GET', '/api/v1/atlas-static-map', getAtlasStaticMapRequest, headers);
            const responseTransformations = [{ typeName: 'bytes', pathInPayload: ['image'] }];
            const deSerializedResponse = batchFromJson(response, responseTransformations);
            return deSerializedResponse;
          },
          getEmbedMap: (getEmbedMapRequest: GetEmbedMapRequest): Promise<GetEmbedMapResponse> => httpClient.invoke('GET', '/api/v1/embed-map', getEmbedMapRequest, headers),
          getSnapshotMap: async (getSnapshotMapRequest: GetSnapshotMapRequest): Promise<GetSnapshotMapResponse> => {
            const response = await httpClient.invoke('GET', '/api/v1/snapshot-map', getSnapshotMapRequest, headers);
            const responseTransformations = [{ typeName: 'bytes', pathInPayload: ['image'] }];
            const deSerializedResponse = batchFromJson(response, responseTransformations);
            return deSerializedResponse;
          },
          getStaticMap: async (getStaticMapRequest: GetStaticMapRequest): Promise<GetStaticMapResponse> => {
            const response = await httpClient.invoke('GET', '/api/v1/static-map', getStaticMapRequest, headers);
            const responseTransformations = [{ typeName: 'bytes', pathInPayload: ['image'] }];
            const deSerializedResponse = batchFromJson(response, responseTransformations);
            return deSerializedResponse;
          },
        };
        (service as any).getAppleEmbedMap.__http_method = 'GET';
        (service as any).getAppleEmbedMap.__http_url = '/api/v1/dynamic-map-token';
        (service as any).getAtlasStaticMap.__http_method = 'GET';
        (service as any).getAtlasStaticMap.__http_url = '/api/v1/atlas-static-map';
        (service as any).getEmbedMap.__http_method = 'GET';
        (service as any).getEmbedMap.__http_url = '/api/v1/embed-map';
        (service as any).getSnapshotMap.__http_method = 'GET';
        (service as any).getSnapshotMap.__http_url = '/api/v1/snapshot-map';
        (service as any).getStaticMap.__http_method = 'GET';
        (service as any).getStaticMap.__http_url = '/api/v1/static-map';
        return service;
      };
    },
    PlacesServiceV2: () => {
      return (headers?: { [headerName: string]: any }) => {
        const service = {
          getPlace: (getPlaceRequest: GetPlaceRequest): Promise<GetPlaceResponse> => httpClient.invoke('GET', '/v2/place', getPlaceRequest, headers),
        };
        (service as any).getPlace.__http_method = 'GET';
        (service as any).getPlace.__http_url = '/v2/place';
        return service;
      };
    },
  };
};

(WixAtlasServiceWeb as any).__transport = 'http';

export * from './types';
